"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const styles_1 = require("@mui/material/styles");
//
const CustomIcons_1 = require("./CustomIcons");
// ----------------------------------------------------------------------
function Rating(theme) {
    return {
        MuiRating: {
            defaultProps: {
                emptyIcon: (0, jsx_runtime_1.jsx)(CustomIcons_1.StarIcon, {}),
                icon: (0, jsx_runtime_1.jsx)(CustomIcons_1.StarIcon, {}),
            },
            styleOverrides: {
                root: {
                    '&.Mui-disabled': {
                        opacity: 0.48,
                    },
                },
                iconEmpty: {
                    color: (0, styles_1.alpha)(theme.palette.grey[500], 0.48),
                },
                sizeSmall: {
                    '& svg': {
                        width: 20,
                        height: 20,
                    },
                },
                sizeLarge: {
                    '& svg': {
                        width: 28,
                        height: 28,
                    },
                },
            },
        },
    };
}
exports.default = Rating;
